<template>
    <b-navbar 
        :class="[$route.name == 'homepage' ? 'is-opacity-70 shadow is-hidden-desktop' : 'is-opacity-90 shadow is-hidden-desktop']">
        <template slot="end">
            <div class="is-hidden-desktop">
                <b-navbar-item>
                    {{ $t("menu.languages") }}
                </b-navbar-item>
                <b-navbar-item
                    v-for="(language, langIndex) in languages"
                    v-bind:key="'lang'+langIndex"
                     @click="changeLanguage(language)" >
                    {{ $t("languages."+language) }}
                </b-navbar-item>
                <b-navbar-item>
                    {{ $t("menu.pages") }}
                </b-navbar-item>
                <b-navbar-item 
                    v-for="(item, itemIndex) in items"
                    v-bind:key="'page'+itemIndex"
                    tag="router-link"
                    :to="item == 'homepage' ? '/' : '/'+item"
                    :active="$route.name == item ? true : false"
                    class="is-fullwidth">
                    <u>{{ $t("menu."+item) }}</u>
                </b-navbar-item>
            </div>
        </template>
    </b-navbar>
</template>
<script>
    export default {
        props: ["languages", "items"],
        methods: {
            changeLanguage(lang){
                this.$Progress.start()
                this.$i18n.locale = lang
                this.$Progress.finish()
            }
        }
    }
</script>